import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useDeleteNotificationStore = defineStore('delete_notification', {
    state: () => {
        return {
            all: null
        }
    },
    actions: {
        async init() {
            try {
                if (this.all) return

                const { data } = await http.get(API_ENDPOINTS.DELETENOTIFICATION.INDEX)

                this.all = data
            } catch { /**/ }
        },
        async destroy(id) {
            try {
                await http.delete(API_ENDPOINTS.DELETENOTIFICATION.DESTROY.replace(':id', id))

                this.all = this.all.filter(notification => notification.id.toString() !== id.toString())
            } catch { /**/ }
        },
        async store(payload) {
            try {
                const { data } = await http.post(API_ENDPOINTS.DELETENOTIFICATION.STORE, payload)

                return data.id
            } catch { /**/ }
        }      
    }
})